<script>
    import Fa from 'svelte-fa';
    import { faCircleNotch } from '@fortawesome/pro-regular-svg-icons';

    import { invalidateAll } from '$app/navigation';
    import { browser } from '$app/environment';

    import Button from '$lib/components/Button.svelte';

    let verification = true;

    const enter = () => {
        // Set the cookie, invalidate so the loader has it, and yeah... Good-o...
        const d = new Date();
        d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000); // 30D Window
        document.cookie = `agePromptAccepted=true; path=/; expires=${d.toUTCString()};`;
        invalidateAll();
    };
</script>

<div class="absolute bottom-0 left-0 z-40 flex h-screen w-full bg-black/70 backdrop-blur-3xl" />

<div class="fixed inset-0 z-40 flex w-full items-center justify-center p-4 duration-150 ease-in-out">
    <div class="no-scrollbar z-50 max-h-screen w-full max-w-sm overflow-scroll rounded-2xl bg-base-900 px-6 py-10 shadow-xl">
        <div class="flex flex-col items-center gap-4 text-center">
            <img alt="Caktus Logo" src="/svg/CaktusLogo.svg" width="176" height="34" fetchpriority="high" class="m-auto w-44 invert dark:invert-0" />

            <p class="font-semibold">Adults Only (18+)</p>
            <p>You must be 18 years of age or older to enter this website. Click Enter only if you are at least 18 years of age.</p>
            <p>Products on our website may contain nicotine, which is an addictive substance.</p>

            <div class="mb-2 flex items-center justify-center">
                <input
                    class="h-4 w-4 rounded-full border-2 border-color-text/50 bg-base-700 text-primary shadow-sm ring-red-700 ring-offset-2 disabled:opacity-0"
                    type="checkbox"
                    name="verification"
                    id="verification"
                    bind:checked={verification}
                    required
                />
                <label for="verification" class="ms-2 text-xs">I am 18 years of age or older</label>
            </div>

            <Button style="Featured" onclick={enter} disabled={!verification || !browser} vibrate={10}>
                {#if browser}<span class="m-auto block">Enter</span>{:else}<Fa icon={faCircleNotch} spin={true} size="1x" class="m-auto block" />{/if}
            </Button>
        </div>
    </div>
</div>
